/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { Scrollbars } from "react-custom-scrollbars";
import { Row, Col } from "react-bootstrap";
import ReactTooltip from "react-tooltip";
import FishboneChart from "fishbone-chart";
//components
// ui kit components
//assets
import { TooltipInfoIcon } from "assets/Iconsv2/Iconsv2";
import { useTranslation } from "react-i18next";
//constant

const DetailStep2 = ({ state, functionContent, variablesObj }) => {
  const { isApproveEnabled } = variablesObj ?? {};
  const { nmDetail } = state ?? {};
  const { t } = useTranslation(["nm", "util"]);
  return (
    <div>
      <div className="row mt-3">
        <div className="col-12 col-md-12 col-lg-12">
          <div className="col-12 col-lg-12 col-md-12 d-flex justify-content-between px-0">
            <div className="clide-v2-title mb-1">
              <label className="clide-v2-fs-4 clide-v2-primary-color fw-bold pt-3 mb-4">
                {" "}
                {t("step2RootCauseAnalysis")}
              </label>
            </div>
            <div className="d-flex align-items-center">
              {/* Search Bar */}
              {/* <div className="input-group me-3" style={{ width: '300px' }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder={t('searchByRootCauseAnalysis')}
                  aria-label="Search"
                  aria-describedby="button-addon2"
                  value={state.rootCauseAnalysisSearchText || ''}
                  onChange={(e) =>
                    functionContent.setState({
                      rootCauseAnalysisSearchText: e.target.value
                    })
                  }
                />
                <button
                  className="btn btn-secondary clide-v2-bg-white clide-v2-border-color border-start-0"
                  type="button"
                  id="button-addon2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={20}
                    height={20}
                    fill="none"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fill="#F56620"
                      d="M8.333 3.334a5 5 0 100 10 5 5 0 000-10zm-6.666 5A6.667 6.667 0 1113.6 12.422l4.49 4.49a.833.833 0 01-1.18 1.178l-4.488-4.49A6.667 6.667 0 011.667 8.334z"
                    ></path>
                  </svg>
                </button>
              </div> */}
            </div>
          </div>
        </div>
        {state.reportStatus == "progress" && isApproveEnabled ? (
          <Row>
            <Col md={5}>
              <div
                className="horizontal-timeline-wrapper shadow-none border  mb-4 "
                style={{ width: "100%" }}
              >
                <div className="timeline-header p-0">
                  <button
                    style={{
                      backgroundColor: "darkgray",
                      color: "white",
                    }}
                    disabled={!isApproveEnabled}
                    className="badge  border font-weight-500 px-3 py-3 rounded-pill"
                    onClick={() => {
                      functionContent.toggleStep2Fun("contributing");
                    }}
                  >
                    {t("contributingFactor")}{" "}
                  </button>
                </div>
                <div className="mx-3 my-3 px-3 pt-5">
                  <Scrollbars
                    style={{ height: "15rem" }}
                    renderView={(props) => (
                      <div
                        style={{
                          paddingRight: "15px",
                          paddingBottom: "1rem",
                          ...props.style,
                          overflowX: "hidden",
                        }}
                      />
                    )}
                  >
                    <div className="pr-4">
                      {nmDetail?.nm_reported_detail_contrubuting_factor_list?.map(
                        (el, idx) => (
                          <div className="user-badge p-3 mb-2 mr-2 w-100">
                            <div key={idx} className="clide-v2-fs-5">
                              {el.factor}
                            </div>
                          </div>
                        ),
                      )}
                    </div>
                  </Scrollbars>
                </div>
              </div>
            </Col>
            <Col md={7}>
              <div
                className="horizontal-timeline-wrapper shadow-none border  mb-4 "
                style={{ width: "100%" }}
              >
                <div className="timeline-header p-0">
                  <button
                    style={{
                      backgroundColor: "darkgray",
                      color: "white",
                    }}
                    className="badge border font-weight-500 px-3 py-3 rounded-pill"
                    onClick={() => {
                      functionContent.toggleStep2Fun("immediate");
                    }}
                    disabled={!isApproveEnabled}
                  >
                    {t("immediateFactor")}{" "}
                  </button>
                </div>
                <div className="mx-3 my-3 px-3 pt-5">
                  <Scrollbars
                    style={{ height: "15rem" }}
                    renderView={(props) => (
                      <div
                        style={{
                          paddingRight: "15px",
                          paddingBottom: "1rem",
                          ...props.style,
                          overflowX: "hidden",
                        }}
                      />
                    )}
                  >
                    <div
                      className="pr-4 d-flex flex-wrap "
                      style={{
                        rowGap: "0.7rem",
                        columnGap: "0.7rem",
                      }}
                    >
                      {nmDetail?.nm_reported_detail_immediate_factor_list?.map(
                        (el, idx) => (
                          <div className="user-badge p-3">
                            <div key={idx} className="clide-v2-fs-5">
                              {el.factor}
                            </div>
                          </div>
                        ),
                      )}
                    </div>
                  </Scrollbars>
                </div>
              </div>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col>
              {/* Contributing Factor  */}

              <div style={{ margin: "2rem" }}>
                {nmDetail.nm_reported_detail_contrubuting_factor_list?.length
                  ? nmDetail.nm_reported_detail_contrubuting_factor_list
                      .slice(
                        0,
                        nmDetail.nm_reported_detail_contrubuting_factor_list
                          .length / 2,
                      )
                      .map((item, index) => (
                        <>
                          <Row>
                            <Col>
                              <div
                                class="vl"
                                style={{
                                  marginLeft: "2rem",
                                  borderLeft: "3px solid red",
                                  height: "2rem",
                                  borderTop: "3px solid red",
                                  width: "1rem",
                                  display: "inline-block",
                                }}
                              ></div>
                              <span
                                style={{
                                  position: "absolute",
                                  lineHeight: "1.2rem",

                                  whiteSpace: "normal",
                                }}
                                className="clide-v2-fs-5"
                              >
                                {item.factor}
                              </span>
                            </Col>
                          </Row>
                        </>
                      ))
                  : null}

                <button
                  style={{
                    background: "red",
                    color: "white",
                    borderRadius: "8px",
                    border: "none",
                    fontFamily: "monospace",
                    padding: "2rem",
                  }}
                  disabled={!isApproveEnabled}
                >
                  {t("contributing")}
                  <br />
                  {t("factor")}
                </button>

                {nmDetail.nm_reported_detail_contrubuting_factor_list?.length
                  ? nmDetail.nm_reported_detail_contrubuting_factor_list
                      .slice(
                        nmDetail.nm_reported_detail_contrubuting_factor_list
                          .length / 2,
                        nmDetail.nm_reported_detail_contrubuting_factor_list
                          .length,
                      )
                      .map((item, index) => (
                        <>
                          <Row>
                            <Col>
                              <div
                                class="vl"
                                style={{
                                  marginLeft: "2rem",
                                  borderLeft: "3px solid red",
                                  height: "2rem",
                                  borderBottom: "3px solid red",
                                  width: "1rem",
                                  display: "inline-block",
                                }}
                              ></div>
                              <span
                                // style={{fontSize:' 2vw !important'}}
                                style={{
                                  position: "absolute",
                                  lineHeight: "1.2rem",

                                  whiteSpace: "normal",
                                }}
                                className="clide-v2-fs-5"
                              >
                                {item.factor}
                              </span>
                            </Col>
                          </Row>
                        </>
                      ))
                  : null}
              </div>
            </Col>

            <Col>
              {/* Immediate Factor  */}

              {nmDetail.nm_reported_detail_immediate_factor_list?.length
                ? nmDetail.nm_reported_detail_immediate_factor_list
                    .slice(
                      0,
                      nmDetail.nm_reported_detail_immediate_factor_list.length /
                        2,
                    )
                    .map((item, index) => (
                      <>
                        <Row>
                          <Col>
                            <div
                              class="vl"
                              style={{
                                marginLeft: "2rem",
                                borderLeft: "3px solid #ff4d6c",
                                height: "2rem",
                                borderTop: "3px solid red",
                                width: "1rem",
                                display: "inline-block",
                              }}
                            ></div>
                            <span
                              style={{
                                position: "absolute",
                                lineHeight: "1.2rem",

                                whiteSpace: "normal",
                              }}
                              className="clide-v2-fs-5"
                            >
                              {item.factor}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ))
                : null}

              <div style={{ margin: "2rem" }}>
                <button
                  style={{
                    background: "#ff4d6c",
                    color: "white",
                    borderRadius: "8px",
                    border: "none",
                    fontFamily: "monospace",
                    padding: "2rem",
                  }}
                >
                  {t("immediate")}
                  <br />
                  {t("factor")}
                </button>
              </div>

              {nmDetail.nm_reported_detail_immediate_factor_list?.length
                ? nmDetail.nm_reported_detail_immediate_factor_list
                    .slice(
                      nmDetail.nm_reported_detail_immediate_factor_list.length /
                        2,
                      nmDetail.nm_reported_detail_immediate_factor_list.length,
                    )
                    .map((item, index) => (
                      <>
                        <Row>
                          <Col>
                            <div
                              class="vl"
                              style={{
                                marginLeft: "2rem",
                                borderLeft: "3px solid #ff4d6c",
                                height: "2rem",
                                borderBottom: "3px solid red",
                                width: "1rem",
                                display: "inline-block",
                              }}
                            ></div>
                            <span className="clide-v2-fs-5">{item.factor}</span>
                          </Col>
                        </Row>
                      </>
                    ))
                : null}
            </Col>
            <Col>
              {/* Root Cause Analysis  */}

              <div style={{ margin: "2rem" }}></div>
            </Col>
          </Row>
        )}
        <Row className="mt-5">
          <Col>
            <div className="justify-content-center d-flex fishbon-chart-wrapper ">
              <div
                className="horizontal-timeline-wrapper shadow-none border  mb-4 "
                style={{ width: "100%" }}
              >
                <div className="timeline-header p-0">
                  <button
                    style={{
                      backgroundColor: "darkgray",
                      color: "white",
                    }}
                    className="badge  border font-weight-500 px-3 py-3 rounded-pill"
                    disabled={!isApproveEnabled}
                    onClick={() => {
                      if (state.reportStatus == "progress") {
                        functionContent.toggleStep2Fun("root cause");
                      }
                    }}
                  >
                    {state.reportStatus == "progress"
                      ? t("addRootCauseAnalysis")
                      : t("rootCauseAnalysis")}
                  </button>
                </div>
                <div className="mx-3 my-3 px-3 pt-5">
                  <div className="d-flex-center overflow-auto py-4">
                    {/* Root Cause<br/>Analysis */}
                    <FishboneChart data={state.FishData} />
                    <div className="ml-2 ">
                      <ReactTooltip
                        effect="solid"
                        place="right"
                        id={`Fishbone`}
                      >
                        <>
                          <div className="output-text font-16 font-weight-500 ">
                            {t("rootCauseAnalysis")}
                          </div>
                        </>
                      </ReactTooltip>
                      <TooltipInfoIcon data-tip data-for={`Fishbone`} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default DetailStep2;
